// AUTO-GENERATED — do not edit. Run `pnpm build` in packages/domain-data.
// Source: business/ishvaram/data/domain/astrology/life_domains.yaml

export type LifeDomainId =
  | "career"
  | "marriage"
  | "health"
  | "wealth"
  | "education"
  | "family"
  | "spiritual"
  | "legal"
  | "travel"
  | "protection";

export interface LifeDomain {
  id: LifeDomainId;
  name_en: string;
  name_hi: string;
  emoji: string;
  houses: number[];
  planets: string[];
  description_en: string;
  description_hi: string;
  sample_questions: string[];
  default_persona: string;
}

export const lifeDomains: readonly LifeDomain[] = [
  {
    id: "career",
    name_en: "Career & Profession",
    name_hi: "जीविका एवं व्यवसाय",
    emoji: "💼",
    houses: [2, 6, 10, 11],
    planets: ["Sun", "Saturn", "Mercury", "Jupiter"],
    description_en:
      "Job growth, business success, promotions, career changes, professional relationships, and finding your true calling.",
    description_hi:
      "नौकरी में वृद्धि, व्यापार सफलता, पदोन्नति, करियर बदलाव, व्यावसायिक संबंध और अपनी सच्ची बुलाहट खोजना।",
    sample_questions: [
      "When is the best time to switch jobs?",
      "Will my business succeed this year?",
      "Which career suits my chart?",
    ],
    default_persona: "pandit_joshi",
  },
  {
    id: "marriage",
    name_en: "Marriage & Relationships",
    name_hi: "विवाह एवं संबंध",
    emoji: "💑",
    houses: [5, 7, 8, 12],
    planets: ["Venus", "Jupiter", "Moon", "Mars"],
    description_en:
      "Marriage timing, compatibility, love life, Mangal Dosha analysis, relationship issues, and finding the right partner.",
    description_hi:
      "विवाह का समय, अनुकूलता, प्रेम जीवन, मांगलिक दोष विश्लेषण, रिश्तों की समस्याएं और सही साथी खोजना।",
    sample_questions: [
      "When will I get married?",
      "Is there Mangal Dosha in my chart?",
      "Will my relationship last?",
    ],
    default_persona: "pandit_dubey",
  },
  {
    id: "health",
    name_en: "Health & Wellness",
    name_hi: "स्वास्थ्य एवं कल्याण",
    emoji: "🏥",
    houses: [1, 6, 8, 12],
    planets: ["Sun", "Moon", "Mars", "Saturn"],
    description_en:
      "Physical health, mental well-being, chronic conditions, recovery timing, Ayurvedic constitution, and preventive measures from your chart.",
    description_hi:
      "शारीरिक स्वास्थ्य, मानसिक कल्याण, दीर्घकालिक रोग, स्वास्थ्य लाभ का समय, आयुर्वेदिक प्रकृति और कुंडली से निवारक उपाय।",
    sample_questions: [
      "What health issues should I watch for?",
      "When will my health improve?",
      "What Ayurvedic constitution does my chart indicate?",
    ],
    default_persona: "vaidya_ayush",
  },
  {
    id: "wealth",
    name_en: "Wealth & Finance",
    name_hi: "धन एवं वित्त",
    emoji: "💰",
    houses: [2, 5, 9, 11],
    planets: ["Jupiter", "Venus", "Mercury", "Moon"],
    description_en:
      "Financial growth, investments, property, debts, windfalls, Dhana Yoga, and strategies for wealth accumulation based on your chart.",
    description_hi:
      "वित्तीय वृद्धि, निवेश, संपत्ति, ऋण, अप्रत्याशित लाभ, धन योग और कुंडली आधारित धन संचय की रणनीतियाँ।",
    sample_questions: [
      "Will I become wealthy?",
      "When is the best time to invest?",
      "Do I have Dhana Yoga in my chart?",
    ],
    default_persona: "guru_lakshmi",
  },
  {
    id: "education",
    name_en: "Education & Learning",
    name_hi: "शिक्षा एवं विद्या",
    emoji: "📚",
    houses: [4, 5, 9, 10],
    planets: ["Mercury", "Jupiter", "Sun", "Moon"],
    description_en:
      "Academic success, competitive exams, higher education, study abroad, learning abilities, and intellectual growth paths.",
    description_hi:
      "शैक्षणिक सफलता, प्रतियोगी परीक्षाएं, उच्च शिक्षा, विदेश में अध्ययन, सीखने की क्षमताएं और बौद्धिक विकास के मार्ग।",
    sample_questions: [
      "Will I clear my competitive exam?",
      "Should I study abroad?",
      "Which field of study suits me best?",
    ],
    default_persona: "devi_saraswati",
  },
  {
    id: "family",
    name_en: "Family & Children",
    name_hi: "परिवार एवं संतान",
    emoji: "👨‍👩‍👧‍👦",
    houses: [4, 5, 7, 9],
    planets: ["Moon", "Jupiter", "Venus", "Sun"],
    description_en:
      "Family harmony, children, progeny timing, parenting, ancestral karma (Pitra Dosha), and domestic peace.",
    description_hi:
      "पारिवारिक सामंजस्य, संतान, संतान प्राप्ति का समय, पालन-पोषण, पितृ दोष और घरेलू शांति।",
    sample_questions: [
      "When will I have children?",
      "Is there Pitra Dosha in my chart?",
      "How can I improve family harmony?",
    ],
    default_persona: "pandit_upadhyay",
  },
  {
    id: "spiritual",
    name_en: "Spiritual Growth",
    name_hi: "आध्यात्मिक विकास",
    emoji: "🙏",
    houses: [5, 9, 12],
    planets: ["Jupiter", "Ketu", "Sun", "Moon"],
    description_en:
      "Spiritual evolution, meditation practices, past-life karma, moksha potential, guru connection, and inner transformation.",
    description_hi:
      "आध्यात्मिक विकास, ध्यान अभ्यास, पूर्व जन्म कर्म, मोक्ष क्षमता, गुरु संयोग और आंतरिक परिवर्तन।",
    sample_questions: [
      "What is my spiritual path?",
      "Do I have moksha yoga?",
      "Which mantras are best for me?",
    ],
    default_persona: "mata_gayatri",
  },
  {
    id: "legal",
    name_en: "Legal & Property",
    name_hi: "कानूनी एवं संपत्ति",
    emoji: "⚖️",
    houses: [4, 6, 7, 8],
    planets: ["Saturn", "Mars", "Jupiter", "Rahu"],
    description_en:
      "Legal disputes, property matters, court cases, land issues, inheritance, and resolution timing.",
    description_hi:
      "कानूनी विवाद, संपत्ति मामले, अदालती मुकदमे, भूमि समस्याएं, विरासत और समाधान का समय।",
    sample_questions: [
      "Will I win my court case?",
      "When will my property dispute resolve?",
      "Is this a good time to buy property?",
    ],
    default_persona: "pandit_sharma",
  },
  {
    id: "travel",
    name_en: "Travel & Foreign Settlement",
    name_hi: "यात्रा एवं विदेश",
    emoji: "✈️",
    houses: [3, 9, 12],
    planets: ["Rahu", "Jupiter", "Moon", "Mercury"],
    description_en:
      "Foreign travel, settlement abroad, visa success, relocation timing, and overseas opportunities.",
    description_hi: "विदेश यात्रा, विदेश में बसना, वीज़ा सफलता, स्थानांतरण का समय और विदेशी अवसर।",
    sample_questions: [
      "Will I settle abroad?",
      "When is the best time to travel?",
      "Will my visa be approved?",
    ],
    default_persona: "guru_krishnan",
  },
  {
    id: "protection",
    name_en: "Protection & Obstacles",
    name_hi: "सुरक्षा एवं बाधा निवारण",
    emoji: "🛡️",
    houses: [6, 8, 12],
    planets: ["Rahu", "Ketu", "Saturn", "Mars"],
    description_en:
      "Removing obstacles, protection from negative energies, Kaal Sarp Dosha, Shani Sade Sati, and spiritual shielding.",
    description_hi:
      "बाधाओं का निवारण, नकारात्मक ऊर्जाओं से सुरक्षा, काल सर्प दोष, शनि साढ़ेसाती और आध्यात्मिक कवच।",
    sample_questions: [
      "Why am I facing constant obstacles?",
      "Do I have Kaal Sarp Dosha?",
      "How to handle Shani Sade Sati?",
    ],
    default_persona: "tantrik_bhairav",
  },
] as const;

export const lifeDomainIds: readonly LifeDomainId[] = lifeDomains.map((domain) => domain.id);

export const lifeDomainMap: Readonly<Record<LifeDomainId, LifeDomain>> = Object.fromEntries(
  lifeDomains.map((domain) => [domain.id, domain])
) as Record<LifeDomainId, LifeDomain>;
